import { cloneDeep } from 'lodash'
import React, { useContext, useState, useImperativeHandle, useRef, useEffect } from 'react'
import { useSearchParams } from "react-router-dom";
import D3Icon from '../../../../static/img/3d_0.png'
import BackupIcon from '../../../../static/img/backup.png'
import ForwardIcon from '../../../../static/img/forward.png'
import RemoveIcon from '../../../../static/img/remove.png'
import BackhomeIcon from '../../../../static/img/back.svg'

import TContext from '../../context'
import PContext from '../context'
import { Dialog, Toast, Icon, Button, Divider } from '@nutui/nutui-react';
import uni from "../../../../lib/uni.webview.1.5.6.js";
import saveIcon from '../../../../images/save-model.png';
import saveIcon2 from '../../../../images/save-a-1.png';
import { uploadFile } from '../../../../lib/http';
import * as apis from '../../../../lib/apis'


export const Height = 50

const buttonSave = {
    color: '#485563',
    border: 'none',
    cursor: 'pointer',
    fontSize: '18px',
    fontWeight: 400,
    padding: '10px 12px',
    width: 100,
    display: 'flex',
    alignItems: 'center',
    gap: 8,
};
const iconBox: React.CSSProperties = {
    width: 34,
    height: 34,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0
}

const iconBoxImg: React.CSSProperties = {
    height: "85%",
    display: "block",
    borderRadius: "50%"
}

const orderBtn: React.CSSProperties = {
    color: "#FFFFFF",
    backgroundColor: "#485563",
    fontSize: 14,
    fontWeight: 500,
    height: 30,
    padding: "0 5px",
    borderRadius: 4,
    display: "flex",
    alignItems: "center"
}

export interface Action {
    addStep?: (j: any) => void;
}

export interface Props {
    action?: any
}


const Index = (props: Props) => {

    const [step, setStep] = useState<number>(-1)
    const tc = useContext(TContext)
    const pc = useContext(PContext)
    const [showSaveDialog, setShowSaveDialog] = useState(false);
    const [modelName, setModelName] = useState('');
    const [saving, setSaving] = useState(false);
    const [title, setTitle] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(0);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const [searchParams] = useSearchParams();

    const product_id = searchParams.get("product_id");

    const options = [
        // { text: 'Preview', fontIcon: 'fpd-icon-preview-lightbox', action: () => preview3D() },
        { text: 'Reset', fontIcon: 'fpd-icon-reset', action: (e: any) => clearAllObject() },
    ];
    const [pickerShow, setPickerShow] = useState(false)

    useEffect(() => {
        const handleClickOutside = (event: any) => {
            if (dropdownRef.current && !dropdownRef?.current?.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleSelect = (index: any) => {
        setSelectedOption(index);
        setIsOpen(false);
        options[index].action(null);
    };
    const addStep = (j = null) => {
        const newLength = tc.fabricClient.addEditData(j)
        setStep(newLength - 1)
    }

    useImperativeHandle(props.action, (): Action => ({
        addStep
    }));

    const backDataDisabled = () => {
        return step < 0
    }

    const forwardDataDisabled = () => {
        return ((step + 1) === tc.fabricClient?.getEditData()?.length)
    }

    const backEditData = async (e: any) => {
        e.preventDefault()
        if (backDataDisabled()) {
            return
        }

        const targetStep = step - 1

        Toast.loading(t("加载中"), {
            cover: true,
            closeOnClickOverlay: false,
            duration: 0
        })

        try {
            // 确保即使同步操作也有一点延迟，让loading显示出来
            await new Promise(resolve => setTimeout(resolve, 10))
            if (targetStep === -1) {
                for (let code in tc.fabricClient.canvaes) {
                    tc.fabricClient.canvaes[code].clear()
                    tc.fabricClient.canvaes[code].renderAll()
                }
            } else {
                await tc.fabricClient.recoverEditData(targetStep)
            }

            pc.checkNotEmptyCodes!()
            setStep(targetStep)

            // 确保loading显示足够时间后再切换
            await new Promise(resolve => setTimeout(resolve, 100))
            Toast.hide()
            await new Promise(resolve => setTimeout(resolve, 50))
            Toast.success(t("操作成功"))

        } catch (error) {
            console.error('撤回失败:', error)
            Toast.hide()
            await new Promise(resolve => setTimeout(resolve, 50))
            Toast.fail(t("操作失败"))
        }
    }
    const forwardEditData = async (e: any) => {
        e.preventDefault()
        if (forwardDataDisabled()) {
            return
        }
        let cloneStep: any = cloneDeep(step)
        cloneStep++
        setStep(cloneStep)
        Toast.loading(t("加载中"), {
            cover: true, // 是否展示透明遮罩层
            closeOnClickOverlay: false, // 点击遮罩可关闭
            duration: 0
        })
        await tc.fabricClient.recoverEditData(cloneStep)
        pc.checkNotEmptyCodes!()
        Toast.success(t("操作成功"))
        Toast.hide()
    }

    //清除所有纹样
    const clearAllObject = () => {
        if (pc.notEmptyCodes?.length === 0 && tc.hasUnsavedChanges) {
            return
        }
        Dialog.alert({
            title: t('重置提醒'),
            content: t('重置后，将恢复初始模型，确定重置吗?'),
            okText: t('确定'),
            cancelText: t('取消'),
            onOk: () => {
                if (tc.fabricClient?.canvaes) {
                    Object.keys(tc.fabricClient.canvaes).forEach(code => {
                        const canvas = tc.fabricClient.canvaes[code]
                        if (canvas) {
                            // 删除背景颜色
                            delete canvas.backgroundColor
                            // 清除背景图片
                            // 重置模型位置
                            tc?.titleChange(tc?.detailData?.model_materials.cutparts[0].code, tc?.detailData);
                            canvas.backgroundImage = null
                            canvas.renderAll()
                        }
                    })
                }
                tc.fabricClient.clearAll()
                tc.fabricClient.clearEditData()

                pc.checkNotEmptyCodes!()
                setStep(-1)
                tc?.threeClient?.resetAllColors()
                Toast.success(t("操作成功"))
            }
        });
    }

    //下单
    const readyDoOrder = () => {
        if (tc?.curEvent) { //如果当前有事件未完成，不可提交订单
            Toast.warn(t("请先完成当前的编辑"))
            return
        }
        pc?.doOrder!()
    }
    //保存模型
    const saveModel = async (e: any) => {
        setShowSaveDialog(true);
        setTitle(t('保存模型'));
    }
    const reset = () => {
        if (tc?.detailData?.name) {
            setModelName(tc.detailData.name);
        }
        setShowSaveDialog(false);
    };
    const sleep = (t: number) => {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null)
            }, t)
        })
    }
    const makeAndUploadImage = async (onProgress: any) => {
        //停止3D与2D的更新
        try {

            const data: any = { effect_img: [], cutpart_img: [] }
            for (let i = 0; i < tc?.detailData?.model_materials?.cutparts?.length; i++) {
                let item = tc?.detailData?.model_materials?.cutparts[i]
                if (item.camera) {
                    tc?.threeClient?.setCamera(item.camera.x, item.camera.y, item.camera.z)
                }
                await sleep(300)
                //获取blob
                const blob = await tc?.threeClient?.screePhoto()
                //上传效果图
                const ossData: any = await uploadFile(apis.UPLOAD_IMAGE, blob)
                if (!ossData.data.url) {
                    Toast.fail(t("资源文件上传失败"))
                    return
                }
                data.effect_img.push({
                    code: item.code,
                    img: ossData.data.url
                })
                onProgress(i / (tc?.detailData?.model_materials?.cutparts?.length - 1) * 100)
            }
            return data
        } catch (error) {
            console.log(error, "error")
        }
    }
    const handleConfirmSave = async (type: string) => {
        if (!modelName.trim()) {
            Toast.text(t('请输入模型名称'));
            return;
        }

        setSaving(true);

        try {
            const mdata = await makeAndUploadImage((p: any) => {
            })
            const resourceData: any = {}
            resourceData.canvas_width = tc?.fabricW as number
            resourceData.canvas_data = tc?.fabricClient?.allToJson()
            for (let i = 0; i < resourceData.canvas_data.length; i++) {
                let item = resourceData.canvas_data[i]
                let f = tc?.detailData?.model_materials?.cutparts?.find((j: any) => j.code === item.code)
                if (f) {
                    item.name = f.txt
                }
            }
            resourceData.model_url = tc?.detailData?.model_materials?.obj_url
            resourceData.map_info = tc?.curFabric
            resourceData.materials = mdata
            const ossData: any = await uploadFile(apis.UPLOAD_IMAGE, new Blob([JSON.stringify(resourceData)], { type: 'text/plain' }), "json")
            if (!ossData.data.url) {
                Toast.fail(t("提交失败,请重试"))
                Toast.hide()
                return
            }
            window.opener.postMessage({
                type: 'CUSTOMIZED',
                name: modelName,
                product_id: tc?.detailData?.product_info?.id,
                model_id: tc?.detailData?.product_info?.design_model_id,
                resource_url: ossData.data.url,
                imgs: mdata.effect_img,
                apis: type === '保存模型' ? apis.USER_DESIGNER_UPDATE + '/' + tc?.detailData?.user_designer?.id : apis.USER_DESIGNER_SAVE
            }, '*');
            reset()
            setSaving(false);
            Toast.success(t("操作成功"))
        } catch (error) {
            Toast.hide()
        }
    }
    //监听活动对象变动
    // useEffect(() => {
    //     setClearDisabled(tc?.fabricClient?.isEmptyAll())
    // }, [tc.curActivityObject])

    const preview3D = () => {
        tc.preview3D!()
    }
    const optionDataHandle = () => {
        const arr = []
        for (let i = 0; i < tc.detailData?.model_materials?.cutparts?.length; i++) {
            let item = tc.detailData?.model_materials?.cutparts[i]
            arr.push({ text: item.txt, value: item.code })
        }
        if (!tc.curCutpartCode) {
            return []
        }
        return arr
    }
    const cutpartOptions = optionDataHandle()
    return (
        <div style={{
            height: Height,
            display: "flex",
            alignItems: "center",
            backgroundColor: '#485563',
        }}>
            <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "0 12px",
                margin: "0 auto",
                width: "100%"
            }}>
                <div style={{
                    display: "flex",
                    alignItems: "center"
                }}>

                    <div style={{ padding: '10px', display: 'flex', alignItems: 'center' }}>
                        <div
                            ref={dropdownRef}
                            style={{
                                position: 'relative',
                            }}
                        >
                            {/* 下拉框头部 */}
                            <i className="fpd-icon-menu" style={{ width: '18px', height: '18px', color: '#fff' }} onClick={() => setIsOpen(!isOpen)}></i>
                            {/* 下拉列表 */}
                            {isOpen && (
                                <div
                                    style={{
                                        position: 'absolute',
                                        top: 30,
                                        left: 0,
                                        right: 0,
                                        background: 'white',
                                        borderRadius: '8px',
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                        marginTop: '4px',
                                        zIndex: 1000,
                                        width: '100px',
                                        overflow: 'hidden',
                                    }}
                                >
                                    {!navigator.userAgent.includes('uni-app') && (
                                        <div onClick={() => {
                                            let userAgent = navigator.userAgent;
                                            if (userAgent.indexOf('uni-app') > -1) {
                                                uni.postMessage({
                                                    data: {
                                                        type: 'uni_back'
                                                    }
                                                });
                                            } else {
                                                window.parent.postMessage({
                                                    type: 'uni_back'
                                                }, '*');
                                            }
                                        }} style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            // justifyContent: 'space-between',
                                            width: '100px',
                                            gap: '8px',
                                            height: 18,
                                            padding: '10px 12px',
                                            color: '#485563',
                                        }}>
                                            <img src={BackhomeIcon} style={iconBoxImg} alt="" />
                                            <span>back</span>

                                        </div>
                                    )}
                                    {/* <div style={buttonSave} onClick={saveModel}>
                                        <img src={saveIcon2} alt="" style={{ width: '18px', height: '18px', display: 'flex', justifyContent: 'center', alignItems: 'center', }} />
                                        <span>{t('保存')}</span>
                                    </div> */}
                                    {options.map((option, index) => (
                                        <div
                                            key={index}
                                            style={{
                                                padding: '10px 12px',
                                                cursor: 'pointer',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                                background: 'white',
                                                color: '#485563 ',
                                                borderRadius: index === 0
                                                    ? '8px 8px 0 0'
                                                    : index === options.length - 1
                                                        ? '0 0 8px 8px'
                                                        : '0'
                                            }}
                                            onClick={() => handleSelect(index)}
                                        >
                                            <i className={option.fontIcon} style={{ width: '18px', height: '18px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}></i>
                                            <style>
                                                {`
    .${option.fontIcon}:before {
      color: #485563;
    }
  `}
                                            </style>
                                            <span>{option.text}</span>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            color: '#fff',
                            marginLeft: 12
                        }}>
                            <div onClick={(e) => {
                                setPickerShow(!pickerShow)
                            }} style={{
                                // width: 80,
                                display: "flex",
                                justifyContent: "end",
                                alignItems: "center",
                                fontSize: 14,
                                position: "relative",
                                cursor: 'pointer',
                            }}>
                                {cutpartOptions.map(v => {
                                    const translatedText = t(v.text);
                                    return (
                                        <div
                                            key={v.value}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                tc?.titleChange(v.value);
                                                // if (tc.textAc?.current) {
                                                //     tc.textAc?.current?.confirm();
                                                // }
                                            }}
                                            style={{
                                                padding: '5px 10px',
                                                cursor: 'pointer',
                                                marginRight: 8,
                                                backgroundColor: v.value === tc?.curCutpartCode ? '#1890ff' : 'transparent',
                                                color: v.value === tc?.curCutpartCode ? '#fff' : '#fff',
                                                borderRadius: 4,
                                                border: v.value === tc?.curCutpartCode ? '1px solid #1890ff' : '1px solid rgba(255,255,255,0.3)',
                                                fontSize: 14,
                                                transition: 'all 0.3s',
                                                whiteSpace: 'nowrap',
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor = v.value === tc?.curCutpartCode ? '#1890ff' : 'rgba(255,255,255,0.1)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor = v.value === tc?.curCutpartCode ? '#1890ff' : 'transparent';
                                            }}
                                        >
                                            {translatedText}
                                        </div>
                                    );
                                })}
                            </div>


                        </div>
                    </div>
                </div>
                {/* <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    // width: '120px',
                }}>
                    <div onClick={backEditData} style={{ ...iconBox, opacity: backDataDisabled() ? 0.5 : 1, justifyContent: 'center', alignItems: 'center', }}>
                        <i className="fpd-icon-undo" style={{ width: '30px', height: '30px', display: 'flex', justifyContent: 'center', alignItems: 'center', }}></i>
                    </div>
                    <div onClick={forwardEditData} style={{ ...iconBox, opacity: forwardDataDisabled() ? 0.5 : 1 }}>
                        <i className="fpd-icon-redo" style={{ width: '30px', height: '30px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}></i>
                    </div>
                </div> */}
                <div style={{
                    display: 'flex',
                    alignItems: "center"
                }}>

                    {product_id ? (
                        <div style={orderBtn} onClick={() => readyDoOrder()}>
                            <i className="fpd-icon-done" style={{ width: '30px', height: '30px', display: 'flex', justifyContent: 'center', alignItems: 'center', }}></i>
                        </div>
                    ) : null
                    }
                </div>
                {showSaveDialog && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 10000,
                    }}>
                        <div style={{
                            backgroundColor: 'white',
                            borderRadius: '12px',
                            padding: '24px',
                            width: '70%',
                            maxWidth: '90vw',
                            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)',
                            animation: 'fadeIn 0.3s ease-out',
                        }}>
                            <h3 style={{
                                margin: '0 0 20px 0',
                                fontSize: '18px',
                                fontWeight: '600',
                                color: '#333',
                                textAlign: 'center',
                            }}>
                                {title}
                            </h3>

                            <div style={{ marginBottom: '20px', marginRight: '32px', }}>
                                <input
                                    type="text"
                                    placeholder={t('请输入模型名称')}
                                    value={modelName}
                                    onChange={(e) => setModelName(e.target.value)}
                                    style={{
                                        width: '100%',
                                        height: '44px',
                                        border: '1px solid #e0e0e0',
                                        borderRadius: '6px',
                                        padding: '0 16px',
                                        fontSize: '14px',
                                        outline: 'none',
                                        transition: 'border-color 0.3s',
                                    }}
                                    onFocus={(e) => {
                                        e.target.style.borderColor = '#485563';
                                    }}
                                    onBlur={(e) => {
                                        e.target.style.borderColor = '#e0e0e0';
                                    }}

                                    autoFocus
                                />

                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginTop: '8px',
                                }}>
                                    <span style={{
                                        fontSize: '12px',
                                        color: '#999',
                                    }}>
                                        {modelName.length}/50
                                    </span>
                                </div>
                            </div>

                            <div style={{
                                display: 'flex',
                                gap: '12px',
                                justifyContent: 'flex-end',
                            }}>
                                <button
                                    onClick={reset}
                                    disabled={saving}
                                    style={{
                                        padding: '10px 20px',
                                        border: '1px solid #dcdfe6',
                                        borderRadius: '6px',
                                        backgroundColor: 'white',
                                        color: '#606266',
                                        cursor: saving ? 'not-allowed' : 'pointer',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        minWidth: '80px',
                                        opacity: saving ? 0.6 : 1,
                                    }}
                                >
                                    {t('取消')}
                                </button>
                                <button
                                    onClick={() => handleConfirmSave('另存为')}
                                    disabled={saving}
                                    style={{
                                        padding: '10px 20px',
                                        border: 'none',
                                        borderRadius: '6px',
                                        backgroundColor: saving ? '#a0cfff' : '#485563',
                                        color: 'white',
                                        cursor: saving ? 'not-allowed' : 'pointer',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        minWidth: '80px',
                                        transition: 'background-color 0.3s',
                                    }}
                                >
                                    {t('另存为')}
                                </button>
                                <button
                                    onClick={() => handleConfirmSave('保存')}
                                    disabled={saving}
                                    style={{
                                        padding: '10px 20px',
                                        border: 'none',
                                        borderRadius: '6px',
                                        backgroundColor: saving ? '#a0cfff' : '#485563',
                                        color: 'white',
                                        cursor: saving ? 'not-allowed' : 'pointer',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        minWidth: '80px',
                                        transition: 'background-color 0.3s',
                                    }}
                                >
                                    {saving ? t('保存中') : t('保存')}
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default Index
